/* global axios */
import ApiClient from './ApiClient';

class KanbanPipelinesAPI extends ApiClient {
  constructor() {
    super('kanban_pipelines', { accountScoped: true });
  }

  getBoard(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/board`);
  }
}

export default new KanbanPipelinesAPI();
